import { updateWebAutomation } from "../webAutomationSlice";

export const createTestCasesUploadedData = (locationKey) =>
  updateWebAutomation(locationKey, "testCasesUploaded", []);

export const updateTestCasesuploadedState = (locationKey, data) =>
    updateWebAutomation(locationKey, "testCasesUploaded", data);

export const resetTestCasesUploadedState = (locationKey) =>
  updateWebAutomation(locationKey, "testCasesUploaded", []);
